import React from 'react';
import { StyledSpinner } from '../../styled-spinner/styled-spinner';
import { BonusCarousel } from './componentes/bonus-carousel';
import { BonusPopupLayer } from './componentes/bonus-popup-layer';
import { GetPersonUser } from '@esportal/portal-service';
import { Bonus, CarouselModeEnum, PersonBonus } from '@esportal/portal-service';
import { useMyBonus } from './hooks/use-my-bonus';

export const MyBonus = ({
	personBonus,
	bonusRef,
	userData,
}: {
	personBonus: PersonBonus | null;
	bonusRef: React.RefObject<HTMLElement>;
	userData: GetPersonUser | null;
}): React.ReactElement => {
	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event
	// const trackingManager = useTrackingManager();

	// const [isTracked, setIsTracked] = useState(false);
	const { filteredBonus } = useMyBonus(personBonus);
	const [isBonusPopupVisible, setIsBonusPopupVisible] = React.useState<boolean>(false);
	const [bonusPopupData, setBonusPopupData] = React.useState<Bonus | undefined>(undefined);

	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event

	// useEffect(() => {
	// 	const handleScroll = () => {
	// 		if (!elementRef.current || isTracked) {
	// 			return;
	// 		}

	// 		const rect = elementRef.current.getBoundingClientRect();

	// 		const isVisible =
	// 			rect.top >= 0 &&
	// 			rect.left >= 0 &&
	// 			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
	// 			rect.right <= (window.innerWidth || document.documentElement.clientWidth);

	// 		if (isVisible && filteredBonus) {
	// 			trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: `${filteredBonus.length} bonus` });
	// 			setIsTracked(true);
	// 		}
	// 	};

	// 	window.addEventListener('scroll', handleScroll);
	// 	handleScroll();

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [filteredBonus, isTracked]);

	return (
		<>
			<BonusPopupLayer
				className="bonus__popup"
				bonusPopupData={bonusPopupData}
				isBonusPopupVisible={isBonusPopupVisible}
				setIsBonusPopupVisible={setIsBonusPopupVisible}
				bonusLayerRef={bonusRef}
				userData={userData}
			/>
			{filteredBonus ? (
				<>
					<BonusCarousel
						bonusList={filteredBonus || []}
						carouselMode={CarouselModeEnum.PERSON}
						showButton={true}
						setBonusPopupData={setBonusPopupData}
						setIsBonusPopupVisible={setIsBonusPopupVisible}
					/>
				</>
			) : (
				<StyledSpinner variant="x-large" />
			)}
		</>
	);
};
